import React from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { addMonths, format, startOfMonth } from "date-fns";
import CalendarNavigation from "../CalendarNavigation/CalendarNavigation";
import { getDateLocale } from "./teamOverviewUtils";

const SCOPES = ["all", "project", "delegation", "team"];

const TeamOverviewToolbar = ({
  month,
  onMonthChange,
  scope,
  onScopeChange,
  scopeId,
  onScopeIdChange,
  scopeOptions,
  search,
  onSearchChange,
}) => {
  const { t, i18n } = useTranslation();
  const locale = getDateLocale(i18n.language);

  return (
    <div className="team-overview__toolbar">
      <CalendarNavigation
        label={format(month, "MMMM yyyy", { locale })}
        onPrevious={() => onMonthChange(addMonths(month, -1))}
        onNext={() => onMonthChange(addMonths(month, 1))}
        onToday={() => onMonthChange(startOfMonth(new Date()))}
      />

      <div className="team-overview__filters">
        <Form.Select
          size="sm"
          value={scope}
          onChange={(e) => onScopeChange(e.target.value)}
          aria-label={t("components.Calendar.teamOverview.view_by")}
        >
          {SCOPES.map((value) => (
            <option key={value} value={value}>
              {t(`components.Calendar.teamOverview.scope_${value}`)}
            </option>
          ))}
        </Form.Select>

        {scope !== "all" && (
          <Form.Select
            size="sm"
            value={scopeId}
            onChange={(e) => onScopeIdChange(e.target.value)}
            aria-label={t(`components.Calendar.teamOverview.select_${scope}`)}
          >
            <option value="">{t(`components.Calendar.teamOverview.select_${scope}`)}</option>
            {scopeOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </Form.Select>
        )}

        <Form.Control
          size="sm"
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t("components.Calendar.teamOverview.search_placeholder")}
          aria-label={t("components.Calendar.teamOverview.search_placeholder")}
        />
      </div>
    </div>
  );
};

export default TeamOverviewToolbar;
